import { render, staticRenderFns } from "./club-member-header.vue?vue&type=template&id=5a30a771&scoped=true"
import script from "./club-member-header.vue?vue&type=script&lang=js"
export * from "./club-member-header.vue?vue&type=script&lang=js"
import style0 from "./club-member-header.vue?vue&type=style&index=0&id=5a30a771&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30a771",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a30a771')) {
      api.createRecord('5a30a771', component.options)
    } else {
      api.reload('5a30a771', component.options)
    }
    module.hot.accept("./club-member-header.vue?vue&type=template&id=5a30a771&scoped=true", function () {
      api.rerender('5a30a771', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/club-member/club-member-header/club-member-header.vue"
export default component.exports